import { alias, createModelSchema, list } from "serializr";
import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";
import { ProductModel } from "../../product/ProductModel";
import { RedactorUtils } from "@/modules/redactor/core/RedactorUtils";
import { Schema } from "@/common/Schema";

export class SmartOfferBundleEnergyRefill extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.ENERGY_REFILL);

        this._hasPopup = false;
        this._adUID = null;
        this._products = [];
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    get adUID() {
        return this._adUID;
    }

    set adUID(value) {
        this._adUID = value;
    }

    get hasPopup() {
        return this._hasPopup;
    }

    set hasPopup(value) {
        this._hasPopup = value;
    }

    empty() {
        if (super.empty()) {
            return true;
        }

        return !this.products || this.products.length === 0;
    }

    valid() {
        if (this.empty()) {
            return false;
        }

        if (this.products.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.adUID && !RedactorUtils.getAdPlacement(this.adUID)) {
            return false;
        }

        return super.valid();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleEnergyRefill());
        } else if (target instanceof SmartOfferBundleEnergyRefill) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleEnergyRefill, {
    _products: alias("products", list(ProductModel.schema())),
    _adUID:    alias("ad_uid", Schema.string()),
    _hasPopup: alias("has_popup", Schema.primitive())
});